import { getOutboundMessage } from './outboundUtils';
export function createReverifyCurrentEmailOutbound() {
    return getOutboundMessage({ _type: 'reverify_current_email' });
}
export function createUpdateReverifyEmailOutbound(newEmail) {
    return getOutboundMessage({
        _type: 'update_reverify_email',
        parts: [{ name: 'newEmail', stringValue: newEmail, needsEncoding: true }]
    });
}
export function createReverifyEmailSkippedOutbound() {
    return getOutboundMessage({ _type: 'reverify_email_skipped' });
}
